function CoreWeb() {
}

CoreWeb.fn = {
    init: function () {
        CoreWeb.fn.changeTypePassword.call(this);
        CoreWeb.fn.toggleClass.call(this);
        CoreWeb.fn.toggleShowHideContent.call(this);
    },

    changeTypePassword: function () {
        var _class = {
            showClass: "is-shown",
            hideClass: "is-hidden"
        };

        $(".passcode-switch").on("click", function (e) {
            e.preventDefault();

            var _this = $(this),
                target = $("#" + _this.data("target"));

            target.hasClass(_class.showClass)
                ? (_this.add(target).addClass(_class.hideClass).removeClass(_class.showClass), target.attr("type", "password"))
                : (_this.add(target).addClass(_class.showClass).removeClass(_class.hideClass), target.attr("type", "text"));
        });
    },

    toggleClass: function () {
        $(document).on('click', '.toggle', function (e) {
            var target = $(this).data('target');
            $('[data-content="' + target + '"]').toggleClass('content-active').after('<div class="toggle-overlay" data-target="userAside"></div>');
        });

        $(document).on('click', '.toggle-overlay', function (e) {
            var target = $(this).data('target');
            $('[data-content="' + target + '"]').toggleClass('content-active').next().remove();
        });
    },

    toggleShowHideContent: function () {
        $(document).on('click', '.btn-more', function (e) {
            $("#toggle-content").toggleClass('toggle-show-hide');

            if ($(this).closest('#toggle-content').hasClass('toggle-show-hide')) {
                $(this).text('Xem thêm nội dung');
            } else {
                $(this).text('Thu gọn nội dung');
            }
        });
    },

    rule: function () {
        $(document).ready(function () {
            CoreWeb.fn.init.call(this);
        });
    },
};

CoreWeb.fn.rule();
